const AcceptedReportIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.2 3C16.2 2.8 16.05 2.6 15.8 2.6H13.5V1.75C13.5 0.9 12.85 0.25 12 0.25C11.15 0.25 10.5 0.9 10.5 1.75V2.6H8.2C8 2.6 7.8 2.75 7.8 3V5H16.15V3H16.2Z" />
            <path d="M6.1 4.75H3.4V23.75H20.65V4.75H17.9V6.75H6.1V4.75ZM8.2 14.15L10.7 16.65L15.8 11.5L17 12.7L10.7 19.1L6.95 15.35L8.2 14.15Z" />
        </svg>
    );
}

export default AcceptedReportIcon;